<template>
  <div id="app">
    <el-container>
      <el-header :class="menuShow ? 'show' : ''" style="height: 58px;">
        <div class="wrap">
          <div class="logo">
            <p class="eTitle"></p>
            <!-- <a href="/#/Home" -->
            <a href="/#/aiRecommendation"><img src="./assets/img/ucelinklogo-5.jpg" max-height="100px"
                max-width="150px" alt /></a>
          </div>
          <div class="flex1"></div>
          <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            :router="router">
           
            <el-submenu index="1" style="margin-top: -8px;">
              <template slot="title"><span>{{ $t("menus.product") }}</span></template>
              <el-submenu index="2-4">
                <template slot="title">{{ $t("menus.talentservices") }}</template>
                <el-menu-item index="/consultant">{{ $t("menus.selectjob") }}</el-menu-item>
                <el-menu-item index="/aiRecommendation">{{ $t("menus.aiRecommendation") }}</el-menu-item>
                <el-menu-item index="/jobList">{{ $t("menus.jobpulish") }}</el-menu-item>
              </el-submenu>
              <el-menu-item index="/advertisement">{{ $t("menus.advertisement") }}</el-menu-item>
              <el-menu-item index="/consultingService">{{ $t("menus.consultingService") }}</el-menu-item>
              <el-menu-item index="/activity">{{ $t("menus.activity") }}</el-menu-item>


              <!-- <el-menu-item index="/consultant">{{ $t("menus.selectjob") }}</el-menu-item>
              <el-menu-item index="/jobList">{{ $t("menus.jobpulish") }}</el-menu-item>
              <el-menu-item index="/aiRecommendation">{{ $t("menus.aiRecommendation") }}</el-menu-item> -->
            </el-submenu>
            <el-submenu index="2" style="margin-top: -8px;">
              <template slot="title"><span>{{ $t("menus.aboutus") }}</span></template>
              <el-menu-item index="/aboutus">{{
                $t("menus.aboutus")
              }}</el-menu-item>
              <el-menu-item index="/founder">{{
                $t("menus.founderProfile")
              }}</el-menu-item>
              <el-menu-item index="/contactus">{{ $t("menus.contactus") }}</el-menu-item>
              <el-menu-item index="/news">{{ $t("menus.companynews") }}</el-menu-item>
            </el-submenu>
            <!-- <el-menu-item index="/consultant">{{ $t("menus.selectjob") }}</el-menu-item> -->
          </el-menu>
          <div class="mc_hd_sharebox clearfix">
            <!-- 微信二维码 -->

            <div class="mc_share_wx fl">
              <div class="mc_share_xtbbox">
                <img src="../src/assets/img/20191030182805_5db965b5711b6.png" alt="" />
              </div>
              <div class="mc_share_qrbox"  v-if="this.langpolicy == 'zh'">
                <img src="../src/assets/img/newercode.jpg" alt="" />
              </div>
              <div class="mc_share_qrbox"  v-if="this.langpolicy == 'en'">
                <img src="../src/assets/img/newercodeen.jpg" alt="" />
              </div>
            </div>

            <!-- in链接

            <div class="mc_share_in fl">
              <a
                href="https://www.linkedin.com/company/x-giants/ "
                class="mc_share_xtbbox"
              >
                <img
                  src="../src/assets/img/20191108163533_5dc528d50a279.png"
                  alt=""
                />
              </a>
            </div> -->
          </div>
          <div class="langChange" style="margin-top: -6px;">
            <!-- <button @click="changeLanguage('en')">EN</button>
          <button @click="changeLanguage('zh')">CH</button> -->
            <router-link id="langen" :class="langpolicy == 'en' ? 'active' : ''" to=""
              @click.native="changeLanguage('en')">EN</router-link>
            <router-link id="langzh" to="" :class="langpolicy == 'zh' ? 'active' : ''"
              @click.native="changeLanguage('zh')">CN</router-link>
          </div>
          <div class="menu_btn" @click="menuShow = !menuShow"></div>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <!-- <div class="footer" v-show="isShow"> -->
      <div class="footer" style="display: none;">
        <div class="wrap">
          <div class="flex">
            <div class="logo">
              <img style="width: 300px" src="./assets/img/logo-underside.png" />
              <div class="mc_hd_sharebox clearfix">
                <!-- 微信二维码 -->
                <!-- <h3>关注我们</h3>
                <div class="flex">
                  <div class="mc_share_wx">
                    <div class="mc_share_xtbbox">
                      <img
                        src="../src/assets/img/20191030182828_5db965cc5dd70.png"
                        alt=""
                      />
                    </div>

                    <div class="mc_share_qrbox">
                      <img
                        src="../src/assets/img/bcd1b1571e0b8d970f45cdc2bb67efc.jpg"
                        alt=""
                      />
                    </div>
                  </div>
-->
                <!-- in链接  -->
                <!--
                  <div class="mc_share_in">
                    <a
                      href="https://www.linkedin.com/company/x-giants/ "
                      class="mc_share_xtbbox"
                    >
                      <img
                        src="../src/assets/img/20191030182735_5db96597278dd.png"
                        alt=""
                      />
                    </a>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="flex1"></div>
            <div class="item">
              <h3>{{ $t("menus.contactus") }}</h3>
              <a style="color: white;" href="mailto:info@uc-elink.co.uk">
                <h3>info@uc-elink.co.uk</h3>
              </a>
              <h3 v-if="this.langpolicy == 'en'">
                <a style="color: white;" target="_blank" href="#/privacypolicyen">Privacy Policy</a>
              </h3>
              <h3 v-if="this.langpolicy == 'zh'">
                <a style="color: white;" target="_blank" href="#/privacypolicyzh">{{ $t("aboutus.common1") }}</a>
              </h3>
            </div>
            <div class="item">
              <h3>{{ $t("aboutus.common3") }}</h3>
              <p>
                782 HIGH RD, LONDON <br />
                T. 020 8993 9200<br />
              </p>
            </div>
          </div>
          <div class="share">
            <!--  <router-link to="" class="s1"
              ><img src="./assets/img/f1.png"
            /></router-link>
            <router-link to="" class="s1"
              ><img src="./assets/img/f2.png"
            /></router-link>
            <router-link to="" class="s1"
              ><img src="./assets/img/f3.png"
            /></router-link> -->
            <router-link to="" class="s1"><img src="./assets/img/f4.png" />
              <div class="drop">
                <img src="../src/assets/img/newercode.jpg" />
              </div>
            </router-link>
          </div>
          <div class="copyright">
            <p>
              UCELINK LIMITED, IS A LIMITED COMPANY REGISTERED IN ENGLAND AND
              WALES WITH REGISTERED NUMBER 02389033
            </p>
            <p>OUR REGISTERED OFFICE IS AT 782 HIGH RD.LONDON</p>
            <p>© UC-ELINK 2024 All rights Reserved 保留所有权利</p>
          </div>
        </div>
      </div>

      <div class="foot">
        <div class="wrap">
          <div>© UC-ELINK 2025 {{ $t("aboutus.common4") }}</div>
          <div class="flex">
            <a href="#/privacypolicyzh">{{ $t("aboutus.common1") }}</a>|<a href="#/contactus">{{ $t("aboutus.common2")
              }}</a>|<a href="#/aboutus">{{ $t("aboutus.common3") }}</a>

            <div class="mc_share_wx">
              <div class="mc_share_xtbbox">
                <img src="../src/assets/img/20191030182805_5db965b5711b6.png" alt="" />
              </div>

              <div class="mc_share_qrbox">
                <img src="../src/assets/img/newercode.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mc_aside">
        <ul class="mc_aside_nav">
          <li class="mc_aside_li mc_aside_search">
            <!-- <div class="mc_aside_xtbbox" id="keyBtn">
              <a href="..#/jobList"
                ><img src="./assets/img/aside_xtb3.png" alt=""
              /></a>
            </div> -->
            <div class="mc_aside_xtbbox">
              <img src="./assets/img/20191030182828_5db965cc5dd70.png" alt="" />
            </div>
            <div class="mc_aside_zkbox">
              <div class="box" style="padding: 0;">
                <img src="./assets/img/newercode.jpg" alt="" width="500">
              </div>
            </div>
          </li>
          <li class="mc_aside_li mc_aside_zx">
            <div class="mc_aside_xtbbox">
              <img src="./assets/img/aside_xtb2.png" alt="" />
            </div>
            <div class="mc_aside_zkbox">
              <div class="box">
                <div class="mc_astel_box">
                  <div class="mc_astel_title">{{ $t("menus.businessCo") }}:</div>
                  <div class="mc_astel_num">
                    <a style="color:#063e8d;" href="mailto:info@uc-elink.co.uk">info@uc-elink.co.uk</a>
                  </div>
                </div>
                <div class="mc_astel_box">
                  <div class="mc_astel_title">{{ $t("menus.jobseeker") }}:</div>
                  <div class="mc_astel_num">
                    <a style="color:#063e8d;" href="mailto:recruiting@uc-elink.co.uk">recruiting@uc-elink.co.uk</a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="mc_aside_li mc_aside_top">
            <el-backtop visibility-height="0">
              <div class="mc_aside_xtbbox">
                <div class="mc_astop_btn">
                  <img src="./assets/img/aside_xtb4.png" alt="" />
                  <span>TOP</span>
                </div>
              </div>
            </el-backtop>
          </li>
        </ul>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "2",
      isShow: false,
      menuShow: false,
      langpolicy: "zh",
      gotop: false,
    };
  },
  created() {
    let lang = localStorage.getItem("language");
    if (lang == null) {
      localStorage.setItem("language", 'zh');
    }
  },
  mounted() {
    let l = localStorage.getItem("language");
    this.changeLanguage(l);
    this.langpolicy = l;

    if (this._isMobile()) {
      var obj = document.getElementById("menu2");
      obj.style.marginTop = "7px";
    } else {
      var obj = document.getElementById("menu2");
      obj.style.marginTop = "-8px";
    }
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //切换语言
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.langpolicy = lang;
      console.log(window.location);
      localStorage.setItem("language", lang);

      // document.getElementById("lang" + lang).setAttribute("class", "active");
      // if (lang == "en") {
      //   document.getElementById("langzh").setAttribute("class", "");
      // } else {
      //   document.getElementById("langen").setAttribute("class", "");
      // }

      if (
        window.location.toString().includes("privacypolicyzh") &&
        lang == "en"
      ) {
        this.$router.push({ path: "/privacypolicyen" });
      }

      if (
        window.location.toString().includes("privacypolicyen") &&
        lang == "zh"
      ) {
        this.$router.push({ path: "/privacypolicyzh" });
      }
       
    },

    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);

      this.menuShow = false;
    },

    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-content: center;

  padding: 35px 10px !important;
  background: #fff;
  font-weight: bold;
  font-size: 25;
  // border: 1px solid black;
  //background-color: #fff;

  .logo {
    width: 220px;
    height: 180px;
    padding: -10px;
    margin-top: -25px;
    margin-left: -40px;

    img {
      width: 170px;
      line-height: 50px;
    }
  }

  .langChange {
    width: 90px;
    line-height: 40px;
    border-radius: 40px;
    background: #ed1a22;
    height: 35px;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    padding: 8px;
    box-sizing: border-box;
    align-items: center;

    a {
      display: black;
      width: 40px;
      height: 20px;
      line-height: 20px;
      border-radius: 20px;
      border-radius: 20px;
      text-align: center;
      color: #fff;
    }

    a.active {
      color: #f01b22;
      background: #fff;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.flex {
  display: flex;
}

.footer {
  width: 100%;
  padding: 40px 0;
  background-color: #00237d;
  color: #fff;

  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;

    .content-nav {
      display: flex;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          //    color: #d4edff;
          padding: 10px 0;
        }

        span {
          //    color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }

  .item {
    width: 180px;
    margin-left: 30px;

    h3 {
      font-weight: normal;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .share {
    margin-top: 50px;
    text-align: right;

    a {
      margin-left: 5px;
      display: inline-block;
      position: relative;

      .drop {
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -75px;
        width: 150px;
        display: none;

        img {
          width: 100%;
        }
      }
    }

    a:hover {
      .drop {
        display: block;
      }
    }
  }

  .copyright {
    // height: 30px;
    //   background: #125688;
    text-align: right;
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.8;

    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
